"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewWidgetBoard extends new_item_1.default {
    constructor(newWidgetBoard) {
        super();
        this.columnData = newWidgetBoard.columnData;
        this.columnOrder = newWidgetBoard.columnOrder;
        this.dateData = newWidgetBoard.dateData;
        this.itemType = newWidgetBoard.itemType;
        this.itemId = newWidgetBoard.itemId;
    }
}
exports.default = NewWidgetBoard;
//# sourceMappingURL=new-widgetBoard.js.map